import React, { useEffect, useState, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getQboSession, getQboLastLogin, getThirdPartyStepsCompleted, getThirdPartyImportedStep } from '../../../store/settings/selectors'
import { URLS } from '../../../resources/constants';
import moment from 'moment';
import { thirdPartyApi } from '../../../resources/hooks/api/thirdPartyApiHook';
import { getBranch } from '../../../store/user/selectors'
import BeginningBalanceImportModal from '../../../components/Modal/BeginningBalanceImport/BeginningBalanceImportModal';
import toast from 'react-hot-toast';
import { t } from 'i18next'

interface Props { }

const Dashboard: React.FC<Props> = () => {

    const navigate = useNavigate();
    const { t } = useTranslation("scenes.thirdparty.quickbook.Dashboard");

    const QuickBookSteps = [{
        label: t("wizard.steps.importCOA"),
        value: 1
    }, {
        label: t("wizard.steps.importBB"),
        value: 2
    }, {
        label: t("wizard.steps.importBSPL"),
        value: 3
    }, {
        label: t("wizard.steps.importVendor"),
        value: 4
    }, {
        label: t("wizard.steps.importCustomer"),
        value: 5
    }];
    
    const quickBookSession = useSelector(getQboSession);
    const quickBookLastLogin = useSelector(getQboLastLogin);
    const quickBookStepCompleted = useSelector(getThirdPartyStepsCompleted);
    const quickBookImportedStep = useSelector(getThirdPartyImportedStep);

    const branchData = useSelector(getBranch);

    const { quickBookImportData } = thirdPartyApi();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isOpenBBModal, setIsOpenBBModal] = useState<boolean>(false);
    const [selectedDateBB, setSelectedDateBB] = useState<Date[]>([]);

    useEffect(() => {
        if ( quickBookSession ) {
            navigate(URLS.THIRD_PARTY_CONNECTION)
        }
    }, [])

    const _handleQuickBookImportData = (step: number) => {
        if ( step == 1 && quickBookImportedStep == 1 ) {
            navigate(URLS.QUICKBOOK_COA)
            return;
        }
        if ( step == 2 && quickBookImportedStep == 2 ) {
            navigate(URLS.QUICKBOOK_BB)
            return;
        }
        if ( step == 3 && quickBookImportedStep == 3 ) {
            navigate(URLS.QUICKBOOK_BS_PL)
            return;
        }
        if ( (step == 2 || step == 3) && !selectedDateBB.length ) {
            setIsOpenBBModal(true);
            return;
        }

        const params: any = {};
        params['branch_id'] = +branchData['id'];
        params['step'] = step;

        if (step == 2 ) {
            params['bs_import_start_date'] = moment(selectedDateBB[0]).startOf('month').format('YYYY-MM-DD');
            params['bs_import_end_date'] = moment(selectedDateBB[0]).endOf('month').format('YYYY-MM-DD');
        } else if (step == 3 ) {
            params['bs_import_start_date'] = moment(selectedDateBB[0]).startOf('month').format('YYYY-MM-DD');
            params['bs_import_end_date'] = moment(selectedDateBB[1]).format('YYYY-MM-DD');
        } else if (step > 3 ) {
            toast.error(t("status.notAvailable"));
            return;
        }
        
        setIsLoading(true)
        quickBookImportData(params, (message: string, resp: any) => {
            setIsLoading(false);
            setSelectedDateBB([])
            toast.success(message);
            if ( step == 1 ) {
                navigate(URLS.QUICKBOOK_COA)
            } else if ( step == 2 ) {
                navigate(URLS.QUICKBOOK_BB)
            }  else if ( step == 3 ) {
                localStorage.setItem("qbo_duration", moment(params['bs_import_end_date']).diff(moment(params['bs_import_start_date']), 'months') + 1 + "");
                
                navigate(URLS.QUICKBOOK_BS_PL)
            }
            
        }, (message: string, resp: any) => {
            setIsLoading(false)
            setSelectedDateBB([])
            console.log(resp)
            toast.error(message)
        })
    }

    const _handleBBDateSelection = () => {
        _handleQuickBookImportData(+quickBookStepCompleted + 1);
    }

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-12 align-items-center d-flex justify-content-between">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">
                                {t("page.title")}
                            </h1>
                        </div>
                    </div>
                </div>

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className='d-flex gap-1'>
                            <div className='border-end d-flex flex-column gap-3 pe-5 w-50'>
                                <h6>{t("connection.connectedWith")}</h6>
                                <div className='d-flex gap-4'>
                                    <div className='border' style={{ borderRadius: '5px' }}>
                                        <div className='align-items-center d-flex justify-content-center' style={{ backgroundColor: '#D9D9D9', borderTopRightRadius: '5px', borderTopLeftRadius: '5px', paddingLeft: '20px', paddingRight: '20px', paddingTop: '7px', paddingBottom: '7px' }}>
                                            <img src="quick-book.svg" alt="" className='h-60' />
                                        </div>
                                        <div className='align-items-center d-flex gap-1 justify-content-center pb-1 pt-1'>
                                            <label>Quick Books</label>
                                        </div>
                                    </div>
                                    <span>{t("connection.connectedOn")}: {quickBookLastLogin ? moment(quickBookLastLogin).format('Do MMM YYYY') : 'NA'}</span>
                                </div>
                            </div>
                            <div className='ps-4 w-100'>
                                <h6>{t("wizard.title")}</h6>
                                <div className='d-flex flex-column gap-2 p-4'>
                                    {QuickBookSteps.map((step, index) => {
                                        return (
                                            <div key={index} className='d-flex gap-2 align-items-center'>
                                                <input type="checkbox" id={`step-${index}`} checked={ step.value <= +quickBookStepCompleted } disabled />
                                                <label htmlFor={`step-${index}`} className='mb-0'>{step.label}</label>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="row mt-md-5">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        <Link to={"javascript:void(0)"} className="btn btn-primary" onClick={() => _handleQuickBookImportData(+quickBookStepCompleted + 1)}>
                                            {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <span>{t("actions.continue")}</span>}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                isOpenBBModal &&
                <BeginningBalanceImportModal step={+quickBookStepCompleted + 1} selectDate={setSelectedDateBB} handleBBDateSelection={_handleBBDateSelection} closeModal={() => setIsOpenBBModal(false)} />
            }
        </div>
    )
}

export default Dashboard
